import makeCrud from '@/store/site/localization/crud'

// Stok sayımları — CRUD; start/record/complete aksiyonları sayfa içinde axios ile.
export default makeCrud('ecommerce_stock_count')
